import dayjs from "dayjs";

//

/**
 *
 * @param date Дата, с которой сравниваем
 * @param passedValue Сколько времени прошло от даты, которую указали
 * @param passedUnit Указываем, в каких единицах измерения времени прошло
 * @returns Прошло ли указанное количество времени
 */
export const isPassed = (
  date: dayjs.ConfigType,
  passedValue: number = 0,
  passedUnit: dayjs.ManipulateType = "millisecond",
) => {
  if (!date) return false;
  return dayjs(date).add(passedValue, passedUnit).isBefore();
};
